import { ReactNode } from "react";
import IDSAR from "../../models/dsar/IDSAR";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import styles from './Request.module.scss';
import { Link } from "react-router-dom";

interface IDSARProps {
    dsar: IDSAR;
}

const CellContent = ({ children } : { children: ReactNode }) => (
    <div className={styles.flex}>
        <div className={styles.block}>
            {children}
        </div>
    </div>
);

export default function Request(props: IDSARProps) {
    const { dsar } = props;
    const { t } = useTranslation();

    const created = dayjs(dsar.created!).format("DD/MM/YYYY");

    return (
        <ListGroup.Item action key={dsar.id} as={Link} to={`/sar/${dsar.id}`} className="py-0">
            <Container fluid>
                <Row className="align-items-stretch py-2">
                    <Col xs={12} lg={3} className={styles.cell}>
                        <CellContent>
                            <span className="d-block fw-bold mb-2 mb-lg-0">{dsar.reference}</span>
                        </CellContent>
                    </Col>
                    
                    <Col xs={12} lg={2} className={styles.cell}>
                        <CellContent>
                            <span className="d-block d-lg-none fw-bold">{t("dsar.my.table.headers.custodian")}</span>
                            <span className="d-block">{dsar.custodian}</span>
                        </CellContent>
                    </Col>

                    <Col xs={12} lg={2} className={styles.cell}>
                        <CellContent>
                            <span className="d-block d-lg-none fw-bold">{t("dsar.my.table.headers.type")}</span>
                            <span className="d-block">{dsar.type}</span>
                        </CellContent>
                    </Col>

                    <Col xs={12} lg={3} className={styles.cell}>
                        <CellContent>
                            <span className="d-block d-lg-none fw-bold">{t("dsar.my.table.headers.status")}</span>
                            <span className="d-block">{dsar.status}</span>
                        </CellContent>
                    </Col>

                    <Col xs={12} lg={2} className={styles.cell}>
                        <CellContent>
                            <span className="d-block d-lg-none fw-bold">{t("dsar.my.table.headers.created")}</span>
                            <span className="d-block">{created}</span>
                        </CellContent>
                    </Col>
                </Row>
            </Container>
        </ListGroup.Item>
    );
}